define('SageDotCom/DataLayer/Util/jQueryExtensions',['jquery', "jqueryValidate", "jqueryValidateUnobtrusive"], function($) {
    $.fn.nextOrFirst = function (selector) {
        var next = this.next(selector);
        return (next.length) ? next : this.prevAll(selector).last();
    };

    $.fn.prevOrLast = function (selector) {
        var prev = this.prev(selector);
        return (prev.length) ? prev : this.nextAll(selector).last();
    };

    $.validator.unobtrusive.adapters.add('ischecked', ['valuetocompare'], function (options) {
        options.rules['ischecked'] = options.params;
        if (options.message != null) {
            options.messages['ischecked'] = options.message;
        }
    });

    $.validator.addMethod('ischecked', function (value, element, params) {
        if (typeof value === "undefined" || value == null) {
            return false;
        } else if ($(element).is(':checkbox')) {
            if ($(element).is(':checked')) {
                return true;
            } else {
                return false;
            }
        }
        return params.valuetocompare.toLowerCase() === value.toLowerCase();
    });

    $.validator.unobtrusive.adapters.add('requiredifothernotequals', ['elementtocompare', 'conditionalvalue'], function (options) {
        options.rules['requiredifothernotequals'] = options.params;
        if (options.message != null) {
            options.messages['requiredifothernotequals'] = options.message;
        }
    });

    $.validator.addMethod('requiredifothernotequals', function (value, element, params) {
        var valueFromElement = $('[name="' + params['elementtocompare'] + '"]').val();
        var valueToCompare = params['conditionalvalue'];

        if (valueFromElement.toLowerCase() !== valueToCompare.toLowerCase()) {
            if (typeof value === "undefined" || value == null || value === "") {
                return false;
            } else {
                return true;
            }
        }

        return true;
    });


    /**
     * File upload Content Type
     */
    $.validator.unobtrusive.adapters.addSingleVal("contenttype", "allowedcontenttypes");

    $.validator.addMethod("contenttype", function (value, element, allowedcontenttypes) {
        if (!this.optional(element)) {
            for (var i = 0; i < element.files.length; i++) {
                if (allowedcontenttypes.indexOf(element.files[i].type) < 0) {
                    return false;
                }
            }
        }
        return true;
    });

    /**
     * File upload File Size
     */
    $.validator.unobtrusive.adapters.addSingleVal("filesize", "maxfilesize");
    $.validator.addMethod("filesize", function (value, element, maxfilesize) {
        if (!this.optional(element)) {
            for (var i = 0; i < element.files.length; i++) {
                if (element.files[i].size > maxfilesize) {
                    return false;
                }
            }
        }
        return true;
    });

    // Date Time Span Validator

    $.validator.unobtrusive.adapters.add('timespan', ['min', 'max', 'unit'], function (options) {
        options.rules['timespan'] = [options.params.min, options.params.max, options.params.unit];
        options.messages['timespan'] = options.message;
    });

});
